<template>
  <div>
    <el-dialog
      title="SCM系统登录-重新设置密码(密码已过期)"
      :visible.sync="passwordDialogVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
          ></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
          ></el-input>
        </el-form-item>

        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPasswordChange">取消</el-button>
        <el-button type="primary" @click="submitPasswordForm" :loading="modifyLoading"
          >确认修改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "password-change-dialog",
  props: {
    passwordDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "新密码长度不能少于6位", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          {
            validator: this.validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
      modifyLoading: false
    };
  },
  methods: {
    cancelPasswordChange() {
      this.$refs.passwordForm.resetFields();
      this.$emit("close");
    },
    submitPasswordForm() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          // 在这里执行密码修改逻辑
          // 包括校验旧密码、提交新密码等操作
          // 成功后关闭弹窗
          this.modifyLoading = true
          this.$apis.autoAPi.POST_MODIFY_PASSWORD({
            loginId: this.$store.state.userInfo.loginId,
            modifyCode: this.$store.state.userInfo.loginId,
            modifyName: this.$store.state.userInfo.adminUserName,
            newPassword: this.$utils.encrypt(this.passwordForm.newPassword),
            oldPassword: this.$utils.encrypt(this.passwordForm.oldPassword),
          }).done(resp => {
            this.modifyLoading = false
            this.$message.success('修改成功，请重新登录')
            setTimeout(() => {
              this.$store.dispatch('logout', this.$store.state.userInfo.id)
              this.$router.push('/login')
            }, 1000);
            this.$emit("close");
          }).fail(err => {
            this.modifyLoading = false
            this.$message.error(err.message)
          })
        }
      });
    },
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
  },
};
</script>

<style>
/* 样式可以根据需要进行修改 */
</style>
